import React, { PureComponent } from 'react';
import { func, string } from 'prop-types';
import classnames from 'classnames';

import './HistoryEntry.scss';

export default class HistoryEntry extends PureComponent {
    static propTypes = {
        className: string,
        value: string.isRequired,
        onClick: func.isRequired,
        onDelete: func.isRequired,
    };

    static defaultProps = {
        className: null,
    };

    handleClick = () => {
        const { onClick, value } = this.props;
        if (onClick) {
            onClick(value);
        }
    };

    handleDelete = evt => {
        evt.stopPropagation();

        const { onDelete, value } = this.props;
        if (onDelete) {
            onDelete(value);
        }
    };

    render() {
        const { className, value } = this.props;
        const rootClassnames = classnames(
            'searchBar__history__item',
            className,
        );
        return (
            <div className={rootClassnames}>
                <button
                    className="searchBar__history__item__button"
                    onClick={this.handleClick}
                >
                    <i className="icon icon__history-search" />
                    {value}
                </button>
                <button
                    className="icon icon__cross searchBar__history__item__cross"
                    onClick={this.handleDelete}
                />
            </div>
        );
    }
}
